import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

type Tone = "info" | "warning" | "danger";

const toneStyles: Record<Tone, { background: string; border: string }> = {
    info: { background: colors.infoBg, border: colors.infoBorder },
    warning: { background: colors.warningBg, border: colors.warningBorder },
    danger: { background: colors.dangerBg, border: colors.dangerBorder },
};

export const Wrap = styled.div<{ $tone: Tone }>`
    padding: 14px 16px;
    border: 1px solid ${({ $tone }) => toneStyles[$tone].border};
    border-radius: ${radii.base};
    background: ${({ $tone }) => toneStyles[$tone].background};
`;

export const Title = styled.p`
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const Text = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${colors.textSecondary};
`;
